<template>
  <div>
    <button @click="fileInput" class="btn btn-primary btn-block btn-sm">
      {{ $t('newAction.stepOne.buttonChooseFile') }}
    </button>
    <b-form-file
      id="input-file"
      style="display: none;"
      v-model="file"
      :state="Boolean(file)"
    ></b-form-file>
    <span class="filename">
      {{ file ? file.name : $t('newAction.stepOne.noFileSelected') }}
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EventBus from '../../../../eventBus';

export default {
  name: 'FileInput',

  data: () => ({
    file: null,
    userAuth: null,
  }),

  watch: {
    file: function watchFile(value) {
      if (value !== null) {
        this.setActionImage({ value });
      }
    },
  },

  methods: {
    ...mapActions('actions', ['setActionImage']),
    fileInput() {
      const event = new MouseEvent('click');
      const element = document.getElementById('input-file');
      element.dispatchEvent(event);
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    EventBus.$on('uploadOk', () => {
      this.file = null;
    });
  },
};
</script>

<style scoped>
.filename {
  font-size: 0.75em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/file-input/index.vue